$(document).ready(function() {
    $('#activityTab a').click(function () {
        $(this).tab('show');
    });
})